import React, { FC } from 'react';
import { Avatar } from 'antd';
import defalutLogo from '../../assets/image/logo.png';
import styles from './styles.module.less';
import classnames from 'classnames';

export interface HeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  logo?: string;
  title: string;
  large?: boolean;
}

export const Header: FC<HeaderProps> = (props) => {
  const { logo = defalutLogo, title, large } = props;

  const logoElement = (
    <Avatar className={`${styles.logo} __authing-app-logo`} src={logo} size={large ? 70 : 50}></Avatar>
  );
  const titleElement = <div className={styles.title}>{title}</div>;

  const cls = classnames(styles.container, {
    [styles.large]: large,
  });
  return (
    <div className={cls}>
      {logoElement}
      {titleElement}
    </div>
  );
};
